var _polygon, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "100,10 130.9,70.9 195.1,75.9 146.4,123.6 158.8,190.1 100,158 41.2,190.1 53.6,123.6 4.9,75.9 69.1,70.9",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 10
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    dominantBaseline: "central",
    textAnchor: "middle",
    dy: "0.2em",
    fill: "currentColor",
    fontSize: 35,
    fontWeight: 900,
    fontFamily: "Arial, sans-serif"
  }, "\r\n    BCJ\r\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo);
export default __webpack_public_path__ + "static/media/brand-logo.0978ccc176b7136cf8d035f48bb0df8c.svg";
export { ForwardRef as ReactComponent };